'use client'

import { MenuItem, type MenuItemProps } from 'react-aria-components/Menu'

import { css } from '../../../../styled-system/css'

export function DropdownMenuItem(props: MenuItemProps) {
    return (
        <MenuItem
            className={css({
                display: 'flex',
                width: 'full',
                alignItems: 'center',
                paddingX: '4',
                height: '[28px]',
                color: 'neutral.800',
                whiteSpace: 'nowrap',
                cursor: 'pointer',
                textDecoration: 'none',
                textTransform: 'uppercase',
                _focus: {
                    outline: 'none',
                    color: 'white',
                    backgroundColor: 'info',
                    '& i': {
                        color: 'white',
                    },
                },
            })}
            {...props}
        />
    )
}
